import { useQuery } from '@tanstack/react-query'

import { reviewsApi, reviewKeys, DEFAULT_PAGE_SIZE, DEFAULT_CURRENT_PAGE, processReviews } from '../lib'

interface UseProductReviewsOptions {
  pageSize?: number
  currentPage?: number
}

/**
 * Hook for fetching product reviews
 *
 * Note: No useMemo needed - this hook is consumed by useReviewsState (not a Provider).
 * React 19 Compiler handles memoization automatically.
 */
export function useProductReviews(productSku: string, options: UseProductReviewsOptions = {}) {
  const pageSize = options.pageSize || DEFAULT_PAGE_SIZE
  const currentPage = options.currentPage || DEFAULT_CURRENT_PAGE

  const query = useQuery({
    queryKey: reviewKeys.list(productSku, pageSize, currentPage),
    queryFn: async () => {
      const data = await reviewsApi.getProductReviews(productSku, pageSize, currentPage)
      const reviewsData = data.products.items?.[0]?.reviews?.items || []
      return processReviews(reviewsData)
    },
    enabled: !!productSku,
  })

  return {
    reviews: query.data || [],
    loading: query.isLoading,
    error: query.error,
  }
}
